// useDisableScrolling.js
import { useEffect } from 'react';

const useDisableScrolling = (isActive) => {
  useEffect(() => {
    if (!isActive) return;

    // Stop Lenis smooth-scroll engine (primary scroll driver)
    if (typeof window.lenis?.stop === 'function') window.lenis.stop();

    // Also lock native overflow as a fallback for non-Lenis scrollers
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    return () => {
      if (typeof window.lenis?.start === 'function') window.lenis.start();
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, [isActive]);
};

export default useDisableScrolling;
